// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"6f902828","365":"17fba976","859":"fdf2f2ec","928":"39b1735a"}[chunkId] + ".chunk.css";
};